/* eslint-disable */
import React from "react"
import { useState } from "react"
import Box from "@mui/material/Box"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Grid, Typography, TableContainer, TablePagination, Button } from "@mui/material"
import { Edit } from "@mui/icons-material"
import { useEffect } from "react"
import moment from "moment"
import {INVOICE_APICALL } from "helper/api/api"
import DeleteItem from "helper/my-com/DeleteItem"
import { SOMETHING_ERR, TABLE_PAGINATION_DROPDOWN, TABLE_ROW_PER_PAGE } from "helper/Constant"
import NoData from "helper/my-com/NoData"
import PageLoader from "helper/my-com/PageLoader"
import { toastifyError, toastifySuccess } from "helper/Utility"
import FormControl from "@mui/material/FormControl"
import OutlinedInput from "@mui/material/OutlinedInput"
import BTNLoading from "helper/my-com/BTNLoading"
const DomainOrHosting = () => {
    const [data, setData] = useState([])
    const [page, setPage] = useState(0)
    const [isForm, setIsForm] = useState(false)
    const [errors, setErrors] = useState({})
    const [rowsPerPage, setRowsPerPage] = useState(TABLE_ROW_PER_PAGE)
    const [loader, setLoader] = useState({
        pageLoading: false
    })

    const [value, setValue] = useState({ id: "", clientName: "", domain: "", dateOfIssue: "" })

    const getDataListFun = async () => {
        setLoader({ ...loader, pageLoading: true })
        try {
            const res = await INVOICE_APICALL("admin/listHosting", "GET")
            if (res?.status) {
                setData(res?.data)
            } else {
                setData([])
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoader({ ...loader, pageLoading: false })
        }
    }

    useEffect(() => {
        getDataListFun()
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleChange = (e) => {
        const key = e.target.name
        const value = e.target.value
        setValue((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const handleClose = () => {
        setValue({
            ...value,
            id: "",
            clientName: "",
            domain: "",
            dateOfIssue: ""
        })
        setIsForm(!isForm)
    }

    const editClick = (row) => {
        setIsForm(true)
        setValue({
            id: row?._id,
            clientName: row?.clientName,
            domain: row?.domain,
            dateOfIssue: row?.dateOfIssue ? moment(row.dateOfIssue).format("YYYY-MM-DD") : ""
        })
    }

    const validate = () => {
        const newErrors = {}
        if (!value.clientName) newErrors.clientName = "Client Name is required"
        if (!value.domain) newErrors.domain = "Domain is required"
        if (!value.dateOfIssue) newErrors.dateOfIssue = "Date is required"
        return newErrors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const validationErrors = validate()
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }
        try {
            setLoader((prev) => ({ ...prev, submitLoading: true }))
            const payload = {
                ...(value.id && { id: value.id }),
                clientName: value.clientName,
                domain: value.domain,
                dateOfIssue: value.dateOfIssue ? new Date(value.dateOfIssue).toISOString() : null
            }
            const res = await INVOICE_APICALL("/admin/createOrUpdateHosting", "POST", payload)
            if (res?.status) {
                toastifySuccess(res?.message)
                getDataListFun()
                handleClose()
                setValue({
                    id: "",
                    clientName: "",
                    domain: "",
                    dateOfIssue: ""
                })
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            console.log(error)
            toastifyError(error?.response?.data?.message || "Server Error")
        } finally {
            setLoader((prev) => ({ ...prev, submitLoading: false }))
        }
    }

    return (
        <>
            <div className="section-tittle d-flex justify-content-between align-items-center">
                <Typography variant="h1" className="tittle" sx={{ pt: 0 }}>
                    <span className="shape"></span>Domain Hosting Management
                </Typography>
                <button className="addgigs" style={{ width: "unset" }} onClick={handleClose}>
                    {isForm ? "Cancel" : "ADD"}
                </button>
            </div>
            <Box sx={{ width: "100%", typography: "body1" }}>
                {!isForm ? (
                    <Box className="boxtbale">
                        {loader?.pageLoading ? (
                            <PageLoader />
                        ) : (
                            <>
                                {data.length > 0 ? (
                                    <>
                                        <TableContainer>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell align="left">Client Name</TableCell>
                                                        <TableCell align="left">Domain Name</TableCell>
                                                        <TableCell align="left">Date of Issue</TableCell>
                                                        <TableCell align="right">Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                                                        <TableRow key={row._id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                            <TableCell component="th" scope="row">
                                                                {i + 1}
                                                            </TableCell>
                                                            <TableCell align="left">{row.clientName}</TableCell>
                                                            <TableCell align="left">{row.domain}</TableCell>
                                                            <TableCell align="left">{moment(row.dateOfIssue).format("DD-MMM")}</TableCell>
                                                            <TableCell align="right">
                                                                <div className="but-groups-action">
                                                                    <button onClick={() => editClick(row)} className="editbtn-small">
                                                                        <Edit />
                                                                    </button>
                                                                    <DeleteItem url={"/admin/deleteHosting"} data={row} callFun={getDataListFun} />
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination rowsPerPageOptions={TABLE_PAGINATION_DROPDOWN} component="div" count={data?.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
                                    </>
                                ) : (
                                    <NoData />
                                )}
                            </>
                        )}
                    </Box>
                ) : (
                    <Box className="boxtbale p-4">
                        <Grid container spacing={1} justifyContent={"center"} alignItems={"center"}>
                            <Grid item md={12}>
                                <Grid container spacing={1.5} className="form-inpitcustom">
                                    <Grid item xs={12} sm={12} md={6} className="mb-3">
                                        <FormControl fullWidth>
                                            <label>
                                                <strong>Client Name</strong>
                                            </label>
                                            <OutlinedInput
                                                placeholder="Client Name"
                                                value={value.clientName}
                                                onChange={handleChange}
                                                name="clientName"
                                                className="form-inpitcustomfiled"
                                                error={Boolean(errors.clientName)}
                                            />
                                            {errors.clientName && <div style={{ color: "red", fontSize: "12px" }}>{errors.clientName}</div>}

                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} className="mb-3">
                                        <FormControl fullWidth>
                                            <label>
                                                <strong>Domain</strong>
                                            </label>
                                            <OutlinedInput
                                                placeholder="Domain"
                                                value={value.domain}
                                                onChange={handleChange}
                                                name="domain"
                                                className="form-inpitcustomfiled"
                                                error={Boolean(errors.domain)}
                                            />
                                            {errors.domain && <div style={{ color: "red", fontSize: "12px" }}>{errors.domain}</div>}

                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} className="mb-3">
                                        <FormControl fullWidth>
                                            <label>
                                                <strong>Date</strong>
                                            </label>
                                            <OutlinedInput
                                                type="date"
                                                value={value.dateOfIssue || ""}
                                                onChange={(e) => {
                                                    setValue((prev) => ({ ...prev, dateOfIssue: e.target.value }))
                                                }}
                                                name="dateOfIssue"
                                                className="form-inpitcustomfiled"
                                                error={Boolean(errors.dateOfIssue)}
                                            />
                                            {errors.dateOfIssue && <div style={{ color: "red", fontSize: "12px" }}>{errors.dateOfIssue}</div>}

                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Grid container xs={12} sm={12} justifyContent={"end"} textAlign={"end"} margin={"20px auto 0px"}>
                                    <div className="text-end d-block">
                                        {loader?.submitLoading ? (
                                            <BTNLoading className={"addgigs"} />
                                        ) : (
                                            <Button type="button" className="addgigs" onClick={handleSubmit}>
                                                Save
                                            </Button>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Box>
        </>
    )
}

export default DomainOrHosting
